/** @module SiteAdmin/Project/ProjectLineItemTable */
define([
	"dojo/_base/declare",
	"csi/table/Widget"
], function(declare, Widget) {

	return declare(Widget, {
		/** @property {reflist} selectedSharedSpecSections */
		selectedSharedSpecSections: null,

		onViewCreate: function() {
			this.watch("selectedSharedSpecSections", (name, oldValue, newValue) => {
				this.selectedSharedSpecSections = newValue;
			});
			this.inherited(arguments);
		},
		/**
		 * @override
		 * ProjectLine Items Table View to Group by ProductType
		 */
		onCreateDefaultCustomView(cv) {
			this.inherited(arguments);
			this.setDefaultGroupAndExpand("ProductType");
		}
	});
});